<template>
  <div class="room-group-list" data-testid="room-group-list">
    <StaysGroup
      v-for="group in filteredGroups"
      :key="group.title"
      :group="group"
      :class="{ 'border border-color-warning': group.isDealOfTheDay() }"
      :defaultTab="defaultTab"
      :bookingStayInProgress="bookingStayInProgress"
      :loyaltyConsentAccepted="loyaltyConsentAccepted"
      :isLastRoomTab="isLastRoomTab"
      :currentRoom="currentRoom"
      :rooms="rooms"
      :room="room"
      @selectStay="$emit('selectStay', $event)"
      @roomSelected="handleRoomSelected"
    />
  </div>
</template>

<script>
import Room from '../../domain/Room'
import Stay from '../../domain/Stay'
import StaysGroup from '@/multi-room-display/components/group/StaysGroup'

export default {
  name: 'RoomGroupsList',
  components: { StaysGroup },
  props: {
    room: {
      type: Room
    },
    rooms: {
      type: Array
    },
    defaultTab: {
      type: String
    },
    bookingStayInProgress: {
      type: Stay
    },
    loyaltyConsentAccepted: {
      type: Boolean
    },
    isLastRoomTab: {
      type: Boolean
    },
    currentRoom: {
      type: Number
    }
  },
  computed: {
    filteredGroups: function () {
      return this.room.groups.filter(group => group.getAllStaysLength() !== 0)
    }
  },
  methods: {
    handleRoomSelected(
      roomSelected,
      rates,
      code,
      mealPlan,
      rate,
      mealPlanName,
      rateName,
      dealOfTheDay
    ) {
      if (roomSelected) {
        this.$emit(
          'roomSelected',
          true,
          rates,
          code,
          mealPlan,
          rate,
          mealPlanName,
          rateName,
          dealOfTheDay
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.border {
  &.border-color-warning {
    border-color: #e17e45 !important;
  }
}
</style>
